import { useTabsWidgetContext } from './TabsWidgetContext';

// ---------------------------------------------------------------------------
// TabsContent
// ---------------------------------------------------------------------------

export interface TabsContentProps {
  /** Must match the `value` of one of the parent TabsWidget's `options`. */
  value: string;
  children: React.ReactNode;
}

/**
 * Renders its children only when the parent `TabsWidget` has this `value`
 * selected. Inactive panels are unmounted from the DOM.
 *
 * Must be rendered as a direct or nested child of `TabsWidget`.
 */
export function TabsContent({ value, children }: TabsContentProps) {
  const { selectedValue } = useTabsWidgetContext();
  if (value !== selectedValue) return null;
  return <>{children}</>;
}

// ---------------------------------------------------------------------------
// TabsWidget props (re-exported from the main file for convenience)
// ---------------------------------------------------------------------------

export interface TabOption {
  value: string;
  label: string;
}

export interface TabsWidgetProps {
  options: TabOption[];
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  children?: React.ReactNode;
}
